<template>
    <div>
        <!-- 体型对比模型 -->
        <div class="body-roundness">
            <!-- <model-loading></model-loading> -->
            <div class="person-img" :class="{ 'person-img-width': modelInfo.bdaStatus !== 1 }" v-if="isSupportWebgl.webgl">
                <img class="measure-top" src="../../assets/images/girth/fill@2x.png" />
                <img class="measure-bottom" src="../../assets/images/girth/fill2@2x.png" alt />
                <div class="model-container">
                    <measure-model v-if="dispalyModel" class="measure-model" ref="model" :tcScanId="tcScanIdCopt"
                        @statusDispaly="OnIsDispaly" :show-girth="false"></measure-model>
                    <!-- 日期选择 -->
                    <div class="data-time">
                        <date-select :type="4" :isCreateTime="isCreateTime" @girthContras="onGirthContrasInfo"></date-select>
                    </div>
                </div>
            </div>
            <!-- 判断浏览器支持 -->
            <version-tip v-else :tipMsg="isSupportWebgl.tipMsg" :title="isSupportWebgl.title"
                msgStyle="msg-style"></version-tip>
            
        </div>
        <!-- <TunDataItem :hipdata="hipdata"></TunDataItem> -->
        <tun-data :hipdata="hipdata"></tun-data>
    </div>
</template>
<script>
import {  findHipScanTrueHistory, hipContrasInfo } from '@/assets/js/apolloGql.js'
// findBmScanFileInfos,
import { _toDecimal } from '@/assets/js/util.js'
import isSupportWebgl from '@/assets/js/webgl.js'
import MeasureModel from '@/components/model/Measurehip'
import VersionTip from '@/components/model/VersionTip.vue'
import DateSelect from '@/components/common/DateSelect'
import { mapState } from 'vuex'
import TunData from '@/components/body/TunData'
// import TunDataItem from '@/components/body/TunDataItem'
export default {
    components: {
        MeasureModel,
        VersionTip,
        DateSelect,
        TunData,
        // TunDataItem
    },
    props: {
        isCreateTime: String,
    },
    data() {
        return {
            isSupportWebgl,
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            slideIndex: 0,
            createTime: '.',
            historyDate: [], //历史数据
            scanId: JSON.parse(window.localStorage.getItem('modelInfo')).scanId,
            unit: window.localStorage.getItem('unit'),
            isDispaly: true,
            dispalyModel: false,
            tcScanIdCopt: '',
            hipdata: {},
        }
    },
    computed: {
        ...mapState(['historyScanId', 'historyData'])
    },
    mounted() {
        this.findHipScanTrueHistory()
        if (!this.historyScanId) {
            this.onGirthContrasInfo()
        }
        let shareScanId = window.localStorage.getItem("shareScanId")
            //  分享链接进入取分享报告ScanId
        let shareFlag = !JSON.parse(localStorage.getItem('share')) && shareScanId
        if(shareFlag){
            this.scanId = shareScanId
        } else {
            this.scanId = this.modelInfo.scanId
        }
        // this.getBmGirthInfo()
    },
    methods: {
        OnIsDispaly(data) {
            if (data == 2) {
                this.isDispaly = true
            } else {
                this.isDispaly = false
            }
        },
        inI18n(un){
            if (un === 'in'){
                switch(this.$i18n.locale) {
                    case 'es-ES':
                        return 'pulg.';
                    case 'fr-FR':
                        return 'po.';
                    case 'ar-AR':
                        return 'اﻧﺶ';
                    case 'th-TH':
                        return 'นิ้ว';
                    default:
                        return 'in.';
                }
            }
        },
        // 获取测量对比的数据
        onGirthContrasInfo(tcScanId) {
            this.dispalyModel = false;
            if (tcScanId != null) {
                window.localStorage.setItem('tcScanId', tcScanId)
                this.tcScanIdCopt = this.historyData.scanId
            } else {
                window.localStorage.removeItem('tcScanId', tcScanId)
            }

            this.$apollo
                .query({
                    query: hipContrasInfo,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanId: this.scanId,
                        tcScanId: tcScanId
                    },
                    fetchPolicy: 'network-only'
                })
                .then(res => {
                    this.dispalyModel = true;
                    const data = res.data.hipContrasInfo
                    this.historyDate = []
                    if (data && data.code === 200) {
                        this.hipdata = data.data
                        console.log(this.hipdata, 'hipdata')
                    }
                })
        },
        // 获取历史记录
        findHipScanTrueHistory() {
            this.$apollo
                .query({
                    query: findHipScanTrueHistory,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanTime: window.localStorage.getItem('createTime') ? JSON.parse(window.localStorage.getItem('createTime')) : this.modelInfo.createTime,
                        deviceType: JSON.parse(window.localStorage.getItem('deviceType'))
                    },
                    fetchPolicy: 'network-only'
                })
                .then(res => {
                    const data = res.data.findHipScanTrueHistory
                    this.historyDate = []
                    if (data && data.code === 200) {
                        for (let index = 0; index < data.data.length; index++) {
                            for (let aa = 0; aa < data.data[index].data.length; aa++) {
                                this.historyDate.push(data.data[index].data[aa])
                            }
                        }
                    }
                    this.$store.commit('setHipDataArray', this.historyDate)
                })
        },
        slideTop() {
            if (this.slideIndex === 0) {
                this.slideIndex = this.roundness.length - 1
            } else {
                this.slideIndex -= 1
            }
            this.$refs.model.selectCurve(this.roundness[this.slideIndex].girth)
        },
        slideBottom() {
            this.slideIndex += 1
            if (this.slideIndex === this.roundness.length) {
                this.slideIndex = 0
            }
            this.$refs.model.selectCurve(this.roundness[this.slideIndex].girth)
        },
        setSlideIdx(idx) {
            this.slideIndex = idx
        },
        toDecimal(num, digit) {
            return _toDecimal(num, digit)
        },
    }
}
</script>

<style lang="less" scoped>
.hidden-roundness {
    // display: none;
}

.body-roundness {
    background-image: url('../../assets/images/girth/Background.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: left bottom;
    padding-top: 36px;
    margin: 12px;
    // display: flex;
    // justify-content: center;
    position: relative;
    height: auto;

    // 禁止部分安卓机下图片自动放大
    img {
        pointer-events: none;
    }

    .girth-box {
        // margin-top: 74px
    }

    .model-container {
        position: relative;
    }

    >div {
        // padding-top: 30px;

        .right-roundness-slide {
            background: none;
            position: absolute;
            top: 0px;
            right: 130px;

            .roundness-data {
                position: relative;
                top: 0px;
                right: 3px;
                background-image: url('../../assets/images/girth/jxing@2x.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 89px;
                height: 79px;
                text-align: center;
                font-size: 36px;
                padding-top: 28px;
                margin-bottom: 6px;

                p {
                    line-height: 15px;
                    padding-left: 10px;
                }

                p {
                    display: block;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .model-style {
                position: relative;
                top: 0px;
                right: -90px;
            }

            .model-right {
                position: relative;
                top: 0px;
                left: 5px;
                width: 89px;
                height: 79px;
                background-image: url(../../assets/images/girth/jxing2@2x.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                text-align: center;
                // font-size: 36px;
                padding-top: 28px;

                p {
                    line-height: 15px;
                    padding-right: 10px;
                }

                p {
                    display: block;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
    }

    >.person-img-width {
        width: 100% !important;
        background-position: center bottom !important;
    }

    >.person-img {
        // display: flex;
        // justify-content: center;
        // min-width: 215px;
        margin-bottom: 15px !important;
        // background-image: url(../../assets/images/report_moxing_bg.png);
        // background-size: 135px 57px;
        background-repeat: no-repeat;
        background-position: 58px bottom;
        margin: 0 auto;
        min-height: 300px;

        .measure-top {
            position: absolute;
            left: 8px;
            right: 8px;
            top: 8px;
            width: 96%;
        }

        .measure-bottom {
            position: absolute;
            top: 245px;
            left: 8px;
            right: 8px;
            width: 96%;
        }

        .data-time {
            position: absolute;
            bottom: -10px;
            right: 0;
            left: 0px;
            margin: auto 20px;
            height: 52px;
        }
    }

    .measure-model {
        padding-bottom: 30px;
        height: 300px;
    }
}
</style>

<style lang="less">
.body-roundness {
    .model-loading {
        top: -33px !important;
    }
}
&.ar-AR{
    
    .data-time{
        direction: rtl !important;
    }
    .girth-box{
        direction: ltr !important;
    }
    .p{
        font-size: 18px !important;
    }

}
</style>
